import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/arrow-left.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = { class: "max-w-[533px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] bg-[var(--secondary-color)] rounded-[6px]" }, null, -1)

import { useRouter } from 'vue-router';
import { withDefaults } from 'vue';
import BaseTypography from './BaseTypography.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnButton',
  props: {
    text: {},
    maxWidth: { default: 'small' }
  },
  setup(__props: any) {



const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex gap-x-[76px] cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTypography, {
        text: _ctx.text,
        type: "subtitle",
        color: "var(--primary-color)",
        class: "mb-3"
      }, null, 8, ["text"]),
      _hoisted_3
    ])
  ]))
}
}

})